// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"728a4dd2","352":"5bee8bb0","682":"38744278","701":"17daf61e","954":"ea99e6c7"}[chunkId] + ".chunk.css";
};